import { AssetEntity, assetRepository } from '@peritasai/repository';
import { AssetFilterParams, AssetType } from '@peritasai/types';

const TRAY_SCAN_PAGE_SIZE = 100;

export const getTraysForLocation = (
  locationId: string
): Promise<AssetEntity[]> => {
  const filters: AssetFilterParams = {
    type: AssetType.TRAY,
    locationId,
    pageSize: TRAY_SCAN_PAGE_SIZE,
  };
  return assetRepository.getAssets(filters);
};
